module.exports = __webpack_public_path__ + "static/media/casual-leather.c8832d2f.jpg";